import { List } from 'antd';
import { styled } from 'styled-components';

export const StyledList = styled(List)`
  .ant-list-header {
    border: none;
  }

  .ant-list-footer,
  .ant-list-item {
    display: flex;
    align-items: center;
    padding: 4px 16px;
    border: none !important;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    border-radius: 4px;
  }

  .regular {
    color: ${props => props.theme.colors.secondary.main.text} !important;
    &:hover {
      background-color: ${props => props.theme.colors.secondary.light.surfaceHover} !important;
    }
  }
`;
